import React from "react";
import { NavLink } from "react-router-dom";

import financeBanner from "../../assets/images/finance/finance_banner.png";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import aiPowered from "../../assets/images/finance/ai_powered.png";
import expenseOptization from "../../assets/images/finance/expence_optimization.png";
import automatedCamp from "../../assets/images/finance/automated_campaigns.png";
import regulatoryComp from "../../assets/images/finance/regulatory_compliances.png";
import Cta from "../../components/cta/cta";
import Testimonials from "../../components/home/Testimonials";

const FinancePage = () => {
  const customGridTemplateColumns = "repeat(2, 1fr)";
  const customGap24 = "24px";
  return (
    <>
      <div className="finance-main-wrapper">
        <section className="finance-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <p class="heading16px roboto-regular mb10">
                    <strong>Empowering Finance</strong>{" "}
                  </p>
                  <h1 className="heading39px roboto-bold mb20 text-color-131415">
                    Smarter <span className="text-primary-color">CRM,</span>{" "}
                    <br /> Sharper{" "}
                    <span className="text-primary-color">Finances</span>
                  </h1>
                  <p className="heading16px roboto-regular mb30">
                    Streamline financial workflows, strengthen client <br />{" "}
                    relationships, and maximize ROI with a powerful, <br />{" "}
                    all-in-one platform.
                  </p>

                  <ul className="btn-sec">
                    <li>
                      <NavLink
                        to={"/signup"}
                        className="common-btn-class main-btn-primary roboto-regular"
                      >
                        {" "}
                        Get Started
                      </NavLink>
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={financeBanner}
                    className="img-responsive position-relative"
                    alt="Automate the Boring Stuff, Close the Fun Deals"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section className="homeServices-wrapper _border-top" id="services">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 text-center heading29px">
                Features That’ll Make You Go WOW!
              </h2>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": customGridTemplateColumns,
                  "--grid-gap": customGap24,
                }}
              >
                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={aiPowered}
                    alt="AI-Powered Insights"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    AI-Powered Insights
                  </h3>
                  <p className="heading16px roboto-regular">
                    Identify high-value clients and craft personalized financial
                    plans effortlessly.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={expenseOptization}
                    alt="Expense Optimization"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Expense Optimization
                  </h3>
                  <p className="heading16px roboto-regular">
                    Monitor marketing and operational spend to maximize profits.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={automatedCamp}
                    alt="Automated Campaigns"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Automated Campaigns
                  </h3>
                  <p className="heading16px roboto-regular">
                    Keep clients engaged with tailored email sequences and
                    timely follow-ups.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={regulatoryComp}
                    alt="Regulatory Compliance"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Regulatory Compliance
                  </h3>
                  <p className="heading16px roboto-regular">
                    Protect client data and stay compliant with built-in
                    security
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Let’s Build Your Financial Success Together"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default FinancePage;
